// ======================================================================
// File Name       : InformationDialog
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Modal } from 'react-bootstrap';

class InformationDialog extends React.Component {
  render() {
    const style = {
      background: 'none',
      width: 'auto',
      marginLeft: 0,
      left: 0,
    };
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal}
        size={this.props.mdSize}
        animation={this.props.animation}
        style={style}
      >
        {
          this.props.title &&
          <Modal.Header>
            {this.props.title}
          </Modal.Header>
        }
        <Modal.Body className="text-center">
          <p className="line-height-20"> {this.props.content} </p>
        </Modal.Body>

        <Modal.Footer className="text-center">
          <Button className=" margin-right-10 btn-96" variant="primary" onClick={this.props.onOK}>
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

InformationDialog.defaultProps = { animation: true };
export default InformationDialog;
